import { render, staticRenderFns } from "./WorkActionSelectorButton.vue?vue&type=template&id=c1e8bbf8&scoped=true"
import script from "./WorkActionSelectorButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkActionSelectorButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WorkActionSelectorButton.vue?vue&type=style&index=0&id=c1e8bbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e8bbf8",
  null
  
)

export default component.exports